var _path, _g, _rect, _path2, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _path8, _rect4, _path9, _path10, _polygon, _path11, _rect5, _path12, _path13, _path14, _rect6, _rect7, _path15, _path16, _path17, _path18, _rect8, _path19, _path20, _polygon2, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLegalInsightsV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "401.382px",
    height: "100.833px",
    viewBox: "0 0 401.382 100.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.3696,
    y1: 30.7354,
    x2: 386.3696,
    y2: 99.7529,
    gradientTransform: "matrix(1 0 0 -1 -20.96 100.5322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#010101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    fill: "url(#SVGID_2_)",
    d: "M336.662,8.019c-9.635,9.634-9.635,25.314,0,34.955    c4.672,4.665,10.877,7.234,17.475,7.234c8.476-0.101,12.656-3.366,16.429-6.111l17.492,16.774l7.168,6.873l2.142,2.053    l1.986-2.072l0.372-0.389l0.638-0.666l1.01-1.053l0.01-0.009l-0.021-0.019l-2.301-2.209l-4.336-4.158l-2.303-2.208l-22.406-21.586    c4.609-7.347,3.541-17.008-2.633-23.174c-3.532-3.539-8.233-5.488-13.241-5.488c-5.011,0-9.714,1.949-13.246,5.488    c-7.298,7.297-7.298,19.179,0,26.484c3.539,3.539,8.242,5.488,13.246,5.488c1.831,0,3.625-0.268,5.362-0.793    c0.384,0.189,0.813,0.297,1.271,0.297c1.591,0,2.88-1.29,2.88-2.88c0-1.591-1.289-2.88-2.88-2.88c-1.265,0-2.336,0.816-2.726,1.95    c-1.269,0.349-2.573,0.527-3.908,0.527c-3.991,0-7.75-1.557-10.581-4.381c-5.828-5.827-5.828-15.314-0.002-21.147    c2.833-2.828,6.592-4.382,10.583-4.382c3.996,0,7.751,1.554,10.576,4.38c4.951,4.958,5.773,12.807,1.938,18.736l-1.66,2.183    l-1.457,1.522l4.246,4.074c-3.801,3.181-8.771,5.005-13.65,5.005c-5.588,0-10.846-2.179-14.803-6.135    c-8.166-8.165-8.166-21.454,0-29.618c3.953-3.952,9.211-6.128,14.81-6.128c5.595,0,10.853,2.176,14.802,6.128    c4.273,4.272,6.455,10.178,6.066,16.165c-0.769,0.519-1.273,1.397-1.273,2.391c0,1.59,1.291,2.882,2.883,2.882    c1.59,0,2.879-1.292,2.879-2.882c0-0.739-0.279-1.408-0.736-1.918c0.531-7.143-2.045-14.206-7.146-19.303    c-4.669-4.67-10.875-7.241-17.474-7.241C347.541,0.778,341.332,3.349,336.662,8.019"
  })))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.382,
    y: 43.561,
    fill: "#1DFFA5",
    width: 8.49,
    height: 42.773
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M37.655,60.348c-1.961-1.086-4.327-1.63-7.026-1.63c-2.781,0-5.249,0.599-7.348,1.786     c-2.09,1.188-3.748,2.863-4.917,4.992c-1.169,2.145-1.768,4.649-1.768,7.467c0,2.947,0.654,5.508,1.943,7.625     c1.289,2.108,3.148,3.757,5.543,4.89c2.421,1.151,5.377,1.731,8.775,1.731c1.989,0,3.951-0.185,5.848-0.535     c1.685-0.313,3.223-0.764,4.585-1.325l-0.7-5.664c-1.068,0.433-2.275,0.792-3.591,1.067c-1.667,0.351-3.296,0.535-4.825,0.535     c-2.588,0-4.678-0.471-6.216-1.382c-1.603-0.948-2.652-2.477-3.131-4.558l-0.193-0.838h18.961     c0.027-0.322,0.055-0.635,0.082-0.939c0.038-0.497,0.056-0.984,0.056-1.482c0-2.779-0.534-5.192-1.583-7.172     C41.109,62.956,39.598,61.417,37.655,60.348z M35.952,70.542H24.524l0.129-0.801c0.801-4.76,3.6-5.755,5.811-5.755     c1.446,0,2.652,0.433,3.583,1.3c0.893,0.846,1.5,1.979,1.786,3.389c0.074,0.378,0.12,0.772,0.12,1.179L35.952,70.542     L35.952,70.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M71.045,64.897l-1.215-2.054c-0.765-1.3-1.823-2.321-3.14-3.039c-1.335-0.728-2.846-1.087-4.494-1.087     c-2.283,0-4.355,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.346,5.028c-1.078,2.127-1.621,4.577-1.621,7.293     s0.516,5.156,1.519,7.248c0.985,2.081,2.395,3.719,4.172,4.88c1.759,1.151,3.84,1.741,6.161,1.741     c3.628,0,6.216-1.346,7.919-4.09l1.28-2.071v4.503c0,5.441-3.066,8.325-8.868,8.325c-1.437,0-3.011-0.222-4.696-0.646     c-1.28-0.332-2.432-0.727-3.417-1.179l-0.847,6.64c0.645,0.321,1.455,0.616,2.412,0.883c1.179,0.341,2.478,0.607,3.859,0.802     c1.381,0.192,2.744,0.294,4.042,0.294c5.129,0,9.052-1.316,11.649-3.914c2.597-2.598,3.914-6.475,3.914-11.529V59.584h-7.966     L71.045,64.897z M69.407,77.624c-1.179,1.309-2.708,1.971-4.54,1.971c-1.87,0-3.417-0.663-4.604-1.971     c-1.169-1.289-1.759-2.928-1.759-4.879c0-1.99,0.59-3.639,1.759-4.91c1.188-1.289,2.735-1.942,4.604-1.942     c1.823,0,3.352,0.653,4.54,1.942c1.169,1.271,1.759,2.92,1.759,4.91C71.166,74.695,70.576,76.334,69.407,77.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M106.858,64.989l-1.216-2.154c-0.727-1.299-1.777-2.313-3.103-3.029     c-1.344-0.729-2.891-1.087-4.586-1.087c-2.237,0-4.292,0.626-6.096,1.86c-1.814,1.262-3.279,2.975-4.347,5.11     c-1.078,2.146-1.621,4.632-1.621,7.385c0,2.79,0.506,5.285,1.519,7.413c0.995,2.118,2.385,3.785,4.144,4.954     c1.75,1.179,3.794,1.769,6.078,1.769c3.803,0,6.418-1.363,8.011-4.172l1.216-2.154l0.166,5.451h7.966v-26.75h-7.966     L106.858,64.989z M105.228,77.844c-1.188,1.308-2.717,1.971-4.549,1.971c-1.86,0-3.417-0.664-4.595-1.971     c-1.169-1.289-1.759-2.928-1.759-4.881c0-1.989,0.589-3.646,1.759-4.918c1.188-1.279,2.735-1.934,4.595-1.934     c1.832,0,3.36,0.653,4.549,1.934c1.169,1.281,1.759,2.929,1.759,4.918C106.987,74.907,106.397,76.555,105.228,77.844z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.019,
    y: 43.561,
    fill: "#1DFFA5",
    width: 8.481,
    height: 42.773
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.207,
    y: 59.584,
    fill: "#1DFFA5",
    width: 8.481,
    height: 26.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M155.415,44.647c-1.39,0-2.532,0.433-3.48,1.317c-0.93,0.866-1.381,1.943-1.381,3.278     c0,1.271,0.451,2.32,1.391,3.213c0.948,0.894,2.081,1.336,3.471,1.336c1.391,0,2.523-0.442,3.454-1.336     c0.921-0.894,1.363-1.942,1.363-3.213c0-1.335-0.441-2.413-1.363-3.288C157.938,45.08,156.814,44.647,155.415,44.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M184.965,58.718c-1.731,0-3.27,0.351-4.577,1.06c-1.29,0.69-2.293,1.703-2.993,2.993l-1.216,2.267     l-0.166-5.453h-8.297v26.752h8.49v-14.19c0-1.86,0.406-3.325,1.207-4.374c0.837-1.105,2.063-1.658,3.628-1.658     c2.035,0,4.457,0.977,4.457,5.654v14.568h8.481v-16.43c0-3.701-0.792-6.539-2.348-8.417     C190.085,59.622,187.903,58.718,184.965,58.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M214.064,70.192c-1.796-0.497-2.982-0.939-3.637-1.372c-0.977-0.635-1.18-1.455-1.18-2.016     c0-1.144,0.664-2.496,3.85-2.496c2.615,0,5.304,0.608,8.012,1.805l0.782-5.479c-1.067-0.543-2.403-0.993-3.978-1.334     c-1.795-0.387-3.638-0.581-5.471-0.581c-3.572,0-6.408,0.745-8.416,2.229c-1.98,1.464-2.938,3.444-2.938,6.068     c0,2.265,0.655,3.978,1.991,5.258c1.379,1.308,3.783,2.44,7.146,3.353c1.833,0.487,3.021,0.92,3.628,1.308     c0.745,0.47,1.143,1.188,1.143,2.082c0,1.188-0.765,2.597-4.402,2.597c-1.694,0-3.426-0.249-5.147-0.736     c-1.39-0.387-2.698-0.931-3.922-1.611l-0.866,5.517c1.125,0.683,2.587,1.253,4.375,1.685c2.008,0.498,4.098,0.746,6.217,0.746     c3.83,0,6.84-0.746,8.949-2.219c2.063-1.437,3.059-3.406,3.059-6.031c0-2.229-0.663-3.969-2.026-5.313     C219.83,72.264,217.417,71.104,214.064,70.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M234.305,44.647c-1.392,0-2.532,0.433-3.481,1.317c-0.93,0.866-1.39,1.943-1.39,3.278     c0,1.271,0.46,2.32,1.399,3.213c0.949,0.894,2.08,1.336,3.472,1.336c1.391,0,2.522-0.442,3.444-1.336     c0.93-0.894,1.371-1.942,1.371-3.213c0-1.335-0.441-2.413-1.363-3.288C236.83,45.08,235.696,44.647,234.305,44.647z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.087,
    y: 59.584,
    fill: "#1DFFA5",
    width: 8.49,
    height: 26.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M266.278,64.897l-1.216-2.054c-0.766-1.3-1.822-2.321-3.141-3.039c-1.336-0.728-2.846-1.087-4.494-1.087     c-2.284,0-4.365,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.347,5.028c-1.076,2.127-1.621,4.577-1.621,7.293     s0.516,5.156,1.511,7.248c0.995,2.081,2.403,3.719,4.181,4.88c1.758,1.151,3.84,1.741,6.16,1.741c3.628,0,6.217-1.346,7.92-4.09     l1.271-2.071v4.503c0,5.441-3.066,8.325-8.858,8.325c-1.437,0-3.011-0.222-4.696-0.646c-1.289-0.332-2.432-0.727-3.416-1.179     l-0.848,6.64c0.645,0.321,1.455,0.616,2.413,0.883c1.179,0.341,2.478,0.607,3.858,0.802c1.381,0.192,2.744,0.294,4.043,0.294     c5.129,0,9.051-1.316,11.647-3.914s3.914-6.475,3.914-11.529V59.584h-7.966L266.278,64.897z M264.638,77.624     c-1.18,1.309-2.707,1.971-4.54,1.971c-1.869,0-3.416-0.663-4.604-1.971c-1.168-1.289-1.758-2.928-1.758-4.879     c0-1.99,0.59-3.639,1.758-4.91c1.189-1.289,2.735-1.942,4.604-1.942c1.823,0,3.353,0.653,4.54,1.942     c1.169,1.271,1.759,2.92,1.759,4.91C266.397,74.695,265.808,76.334,264.638,77.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M299.677,58.718c-1.694,0-3.215,0.341-4.512,1.004c-1.271,0.663-2.267,1.621-2.957,2.836l-1.289,2.274     V43.561h-8.49v42.773h8.49V72.145c0-1.859,0.404-3.325,1.207-4.374c0.838-1.104,2.063-1.658,3.627-1.658     c2.026,0,4.449,0.976,4.449,5.654v14.567h8.489V69.907c0-3.701-0.792-6.539-2.349-8.417     C304.789,59.622,302.615,58.718,299.677,58.718z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1DFFA5",
    points: "327.552,52.336 319.07,52.336 319.07,59.584 314.328,59.584 314.328,66.113 319.07,66.113      319.07,86.334 327.552,86.334 327.552,66.113 333.279,66.113 333.279,59.584 327.552,59.584    "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M359.432,73.645c-1.39-1.381-3.804-2.542-7.165-3.453c-1.795-0.497-2.982-0.939-3.627-1.372     c-0.986-0.635-1.188-1.455-1.188-2.016c0-1.144,0.672-2.496,3.857-2.496c2.615,0,5.304,0.608,8.002,1.805l0.783-5.479     c-1.068-0.543-2.404-0.993-3.969-1.334c-1.806-0.387-3.647-0.581-5.471-0.581c-3.582,0-6.418,0.745-8.426,2.229     c-1.979,1.464-2.938,3.444-2.938,6.068c0,2.265,0.653,3.978,1.998,5.258c1.381,1.308,3.785,2.44,7.146,3.353     c1.824,0.487,3.012,0.92,3.619,1.308c0.746,0.47,1.143,1.188,1.143,2.082c0,1.188-0.766,2.597-4.402,2.597     c-1.694,0-3.426-0.249-5.147-0.736c-1.381-0.387-2.698-0.931-3.923-1.611l-0.866,5.517c1.124,0.683,2.597,1.253,4.375,1.685     c2.017,0.498,4.106,0.746,6.216,0.746c3.838,0,6.85-0.746,8.959-2.219c2.053-1.437,3.057-3.406,3.057-6.031     C361.466,76.73,360.804,74.99,359.432,73.645z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.382,
    y: 43.561,
    fill: "#1DFFA5",
    width: 8.49,
    height: 42.773
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M37.655,60.348c-1.961-1.086-4.327-1.63-7.026-1.63c-2.781,0-5.249,0.599-7.348,1.786    c-2.09,1.188-3.748,2.863-4.917,4.992c-1.169,2.145-1.768,4.649-1.768,7.467c0,2.947,0.654,5.508,1.943,7.625    c1.289,2.108,3.148,3.757,5.543,4.89c2.421,1.151,5.377,1.731,8.775,1.731c1.989,0,3.951-0.185,5.848-0.535    c1.685-0.313,3.223-0.764,4.585-1.325l-0.7-5.664c-1.068,0.433-2.275,0.792-3.591,1.067c-1.667,0.351-3.296,0.535-4.825,0.535    c-2.588,0-4.678-0.471-6.216-1.382c-1.603-0.948-2.652-2.477-3.131-4.558l-0.193-0.838h18.961    c0.027-0.322,0.055-0.635,0.082-0.939c0.038-0.497,0.056-0.984,0.056-1.482c0-2.779-0.534-5.192-1.583-7.172    C41.109,62.956,39.598,61.417,37.655,60.348z M35.952,70.542H24.524l0.129-0.801c0.801-4.76,3.6-5.755,5.811-5.755    c1.446,0,2.652,0.433,3.583,1.3c0.893,0.846,1.5,1.979,1.786,3.389c0.074,0.378,0.12,0.772,0.12,1.179L35.952,70.542    L35.952,70.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M71.045,64.897l-1.215-2.054c-0.765-1.3-1.823-2.321-3.14-3.039c-1.335-0.728-2.846-1.087-4.494-1.087    c-2.283,0-4.355,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.346,5.028c-1.078,2.127-1.621,4.577-1.621,7.293    s0.516,5.156,1.519,7.248c0.985,2.081,2.395,3.719,4.172,4.88c1.759,1.151,3.84,1.741,6.161,1.741c3.628,0,6.216-1.346,7.919-4.09    l1.28-2.071v4.503c0,5.441-3.066,8.325-8.868,8.325c-1.437,0-3.011-0.222-4.696-0.646c-1.28-0.332-2.432-0.727-3.417-1.179    l-0.847,6.64c0.645,0.321,1.455,0.616,2.412,0.883c1.179,0.341,2.478,0.607,3.859,0.802c1.381,0.192,2.744,0.294,4.042,0.294    c5.129,0,9.052-1.316,11.649-3.914c2.597-2.598,3.914-6.475,3.914-11.529V59.584h-7.966L71.045,64.897z M69.407,77.624    c-1.179,1.309-2.708,1.971-4.54,1.971c-1.87,0-3.417-0.663-4.604-1.971c-1.169-1.289-1.759-2.928-1.759-4.879    c0-1.99,0.59-3.639,1.759-4.91c1.188-1.289,2.735-1.942,4.604-1.942c1.823,0,3.352,0.653,4.54,1.942    c1.169,1.271,1.759,2.92,1.759,4.91C71.166,74.695,70.576,76.334,69.407,77.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M106.858,64.989l-1.216-2.154c-0.727-1.299-1.777-2.313-3.103-3.029c-1.344-0.729-2.891-1.087-4.586-1.087    c-2.237,0-4.292,0.626-6.096,1.86c-1.814,1.262-3.279,2.975-4.347,5.11c-1.078,2.146-1.621,4.632-1.621,7.385    c0,2.79,0.506,5.285,1.519,7.413c0.995,2.118,2.385,3.785,4.144,4.954c1.75,1.179,3.794,1.769,6.078,1.769    c3.803,0,6.418-1.363,8.011-4.172l1.216-2.154l0.166,5.451h7.966v-26.75h-7.966L106.858,64.989z M105.228,77.844    c-1.188,1.308-2.717,1.971-4.549,1.971c-1.86,0-3.417-0.664-4.595-1.971c-1.169-1.289-1.759-2.928-1.759-4.881    c0-1.989,0.589-3.646,1.759-4.918c1.188-1.279,2.735-1.934,4.595-1.934c1.832,0,3.36,0.653,4.549,1.934    c1.169,1.281,1.759,2.929,1.759,4.918C106.987,74.907,106.397,76.555,105.228,77.844z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.019,
    y: 43.561,
    fill: "#1DFFA5",
    width: 8.481,
    height: 42.773
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.207,
    y: 59.584,
    fill: "#1DFFA5",
    width: 8.481,
    height: 26.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBFF8E",
    d: "M155.415,44.647c-1.39,0-2.532,0.433-3.48,1.317c-0.93,0.866-1.381,1.943-1.381,3.278    c0,1.271,0.451,2.32,1.391,3.213c0.948,0.894,2.081,1.336,3.471,1.336c1.391,0,2.523-0.442,3.454-1.336    c0.921-0.894,1.363-1.942,1.363-3.213c0-1.335-0.441-2.413-1.363-3.288C157.938,45.08,156.814,44.647,155.415,44.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M184.965,58.718c-1.731,0-3.27,0.351-4.577,1.06c-1.29,0.69-2.293,1.703-2.993,2.993l-1.216,2.267    l-0.166-5.453h-8.297v26.752h8.49v-14.19c0-1.86,0.406-3.325,1.207-4.374c0.837-1.105,2.063-1.658,3.628-1.658    c2.035,0,4.457,0.977,4.457,5.654v14.568h8.481v-16.43c0-3.701-0.792-6.539-2.348-8.417    C190.085,59.622,187.903,58.718,184.965,58.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M214.064,70.192c-1.796-0.497-2.982-0.939-3.637-1.372c-0.977-0.635-1.18-1.455-1.18-2.016    c0-1.144,0.664-2.496,3.85-2.496c2.615,0,5.304,0.608,8.012,1.805l0.782-5.479c-1.067-0.543-2.403-0.993-3.978-1.334    c-1.795-0.387-3.638-0.581-5.471-0.581c-3.572,0-6.408,0.745-8.416,2.229c-1.98,1.464-2.938,3.444-2.938,6.068    c0,2.265,0.655,3.978,1.991,5.258c1.379,1.308,3.783,2.44,7.146,3.353c1.833,0.487,3.021,0.92,3.628,1.308    c0.745,0.47,1.143,1.188,1.143,2.082c0,1.188-0.765,2.597-4.402,2.597c-1.694,0-3.426-0.249-5.147-0.736    c-1.39-0.387-2.698-0.931-3.922-1.611l-0.866,5.517c1.125,0.683,2.587,1.253,4.375,1.685c2.008,0.498,4.098,0.746,6.217,0.746    c3.83,0,6.84-0.746,8.949-2.219c2.063-1.437,3.059-3.406,3.059-6.031c0-2.229-0.663-3.969-2.026-5.313    C219.83,72.264,217.417,71.104,214.064,70.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBFF8E",
    d: "M234.305,44.647c-1.392,0-2.532,0.433-3.481,1.317c-0.93,0.866-1.39,1.943-1.39,3.278    c0,1.271,0.46,2.32,1.399,3.213c0.949,0.894,2.08,1.336,3.472,1.336c1.391,0,2.522-0.442,3.444-1.336    c0.93-0.894,1.371-1.942,1.371-3.213c0-1.335-0.441-2.413-1.363-3.288C236.83,45.08,235.696,44.647,234.305,44.647z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.087,
    y: 59.584,
    fill: "#1DFFA5",
    width: 8.49,
    height: 26.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M266.278,64.897l-1.216-2.054c-0.766-1.3-1.822-2.321-3.141-3.039c-1.336-0.728-2.846-1.087-4.494-1.087    c-2.284,0-4.365,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.347,5.028c-1.076,2.127-1.621,4.577-1.621,7.293    s0.516,5.156,1.511,7.248c0.995,2.081,2.403,3.719,4.181,4.88c1.758,1.151,3.84,1.741,6.16,1.741c3.628,0,6.217-1.346,7.92-4.09    l1.271-2.071v4.503c0,5.441-3.066,8.325-8.858,8.325c-1.437,0-3.011-0.222-4.696-0.646c-1.289-0.332-2.432-0.727-3.416-1.179    l-0.848,6.64c0.645,0.321,1.455,0.616,2.413,0.883c1.179,0.341,2.478,0.607,3.858,0.802c1.381,0.192,2.744,0.294,4.043,0.294    c5.129,0,9.051-1.316,11.647-3.914s3.914-6.475,3.914-11.529V59.584h-7.966L266.278,64.897z M264.638,77.624    c-1.18,1.309-2.707,1.971-4.54,1.971c-1.869,0-3.416-0.663-4.604-1.971c-1.168-1.289-1.758-2.928-1.758-4.879    c0-1.99,0.59-3.639,1.758-4.91c1.189-1.289,2.735-1.942,4.604-1.942c1.823,0,3.353,0.653,4.54,1.942    c1.169,1.271,1.759,2.92,1.759,4.91C266.397,74.695,265.808,76.334,264.638,77.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M299.677,58.718c-1.694,0-3.215,0.341-4.512,1.004c-1.271,0.663-2.267,1.621-2.957,2.836l-1.289,2.274    V43.561h-8.49v42.773h8.49V72.145c0-1.859,0.404-3.325,1.207-4.374c0.838-1.104,2.063-1.658,3.627-1.658    c2.026,0,4.449,0.976,4.449,5.654v14.567h8.489V69.907c0-3.701-0.792-6.539-2.349-8.417    C304.789,59.622,302.615,58.718,299.677,58.718z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1DFFA5",
    points: "327.552,52.336 319.07,52.336 319.07,59.584 314.328,59.584 314.328,66.113 319.07,66.113     319.07,86.334 327.552,86.334 327.552,66.113 333.279,66.113 333.279,59.584 327.552,59.584   "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DFFA5",
    d: "M359.432,73.645c-1.39-1.381-3.804-2.542-7.165-3.453c-1.795-0.497-2.982-0.939-3.627-1.372    c-0.986-0.635-1.188-1.455-1.188-2.016c0-1.144,0.672-2.496,3.857-2.496c2.615,0,5.304,0.608,8.002,1.805l0.783-5.479    c-1.068-0.543-2.404-0.993-3.969-1.334c-1.806-0.387-3.647-0.581-5.471-0.581c-3.582,0-6.418,0.745-8.426,2.229    c-1.979,1.464-2.938,3.444-2.938,6.068c0,2.265,0.653,3.978,1.998,5.258c1.381,1.308,3.785,2.44,7.146,3.353    c1.824,0.487,3.012,0.92,3.619,1.308c0.746,0.47,1.143,1.188,1.143,2.082c0,1.188-0.766,2.597-4.402,2.597    c-1.694,0-3.426-0.249-5.147-0.736c-1.381-0.387-2.698-0.931-3.923-1.611l-0.866,5.517c1.124,0.683,2.597,1.253,4.375,1.685    c2.017,0.498,4.106,0.746,6.216,0.746c3.838,0,6.85-0.746,8.959-2.219c2.053-1.437,3.057-3.406,3.057-6.031    C361.466,76.73,360.804,74.99,359.432,73.645z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.382,
    y: 43.561,
    fill: "url(#SVGID_3_)",
    width: 8.49,
    height: 42.773
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M37.655,60.348c-1.961-1.086-4.327-1.63-7.026-1.63c-2.781,0-5.249,0.599-7.348,1.786     c-2.09,1.188-3.748,2.863-4.917,4.992c-1.169,2.145-1.768,4.649-1.768,7.467c0,2.947,0.654,5.508,1.943,7.625     c1.289,2.108,3.148,3.757,5.543,4.89c2.421,1.151,5.377,1.731,8.775,1.731c1.989,0,3.951-0.185,5.848-0.535     c1.685-0.313,3.223-0.764,4.585-1.325l-0.7-5.664c-1.068,0.433-2.275,0.792-3.591,1.067c-1.667,0.351-3.296,0.535-4.825,0.535     c-2.588,0-4.678-0.471-6.216-1.382c-1.603-0.948-2.652-2.477-3.131-4.558l-0.193-0.838h18.961     c0.027-0.322,0.055-0.635,0.082-0.939c0.038-0.497,0.056-0.984,0.056-1.482c0-2.779-0.534-5.192-1.583-7.172     C41.109,62.956,39.598,61.417,37.655,60.348z M35.952,70.542H24.524l0.129-0.801c0.801-4.76,3.6-5.755,5.811-5.755     c1.446,0,2.652,0.433,3.583,1.3c0.893,0.846,1.5,1.979,1.786,3.389c0.074,0.378,0.12,0.772,0.12,1.179L35.952,70.542     L35.952,70.542z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M71.045,64.897l-1.215-2.054c-0.765-1.3-1.823-2.321-3.14-3.039     c-1.335-0.728-2.846-1.087-4.494-1.087c-2.283,0-4.355,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.346,5.028     c-1.078,2.127-1.621,4.577-1.621,7.293s0.516,5.156,1.519,7.248c0.985,2.081,2.395,3.719,4.172,4.88     c1.759,1.151,3.84,1.741,6.161,1.741c3.628,0,6.216-1.346,7.919-4.09l1.28-2.071v4.503c0,5.441-3.066,8.325-8.868,8.325     c-1.437,0-3.011-0.222-4.696-0.646c-1.28-0.332-2.432-0.727-3.417-1.179l-0.847,6.64c0.645,0.321,1.455,0.616,2.412,0.883     c1.179,0.341,2.478,0.607,3.859,0.802c1.381,0.192,2.744,0.294,4.042,0.294c5.129,0,9.052-1.316,11.649-3.914     c2.597-2.598,3.914-6.475,3.914-11.529V59.584h-7.966L71.045,64.897z M69.407,77.624c-1.179,1.309-2.708,1.971-4.54,1.971     c-1.87,0-3.417-0.663-4.604-1.971c-1.169-1.289-1.759-2.928-1.759-4.879c0-1.99,0.59-3.639,1.759-4.91     c1.188-1.289,2.735-1.942,4.604-1.942c1.823,0,3.352,0.653,4.54,1.942c1.169,1.271,1.759,2.92,1.759,4.91     C71.166,74.695,70.576,76.334,69.407,77.624z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M106.858,64.989l-1.216-2.154c-0.727-1.299-1.777-2.313-3.103-3.029     c-1.344-0.729-2.891-1.087-4.586-1.087c-2.237,0-4.292,0.626-6.096,1.86c-1.814,1.262-3.279,2.975-4.347,5.11     c-1.078,2.146-1.621,4.632-1.621,7.385c0,2.79,0.506,5.285,1.519,7.413c0.995,2.118,2.385,3.785,4.144,4.954     c1.75,1.179,3.794,1.769,6.078,1.769c3.803,0,6.418-1.363,8.011-4.172l1.216-2.154l0.166,5.451h7.966v-26.75h-7.966     L106.858,64.989z M105.228,77.844c-1.188,1.308-2.717,1.971-4.549,1.971c-1.86,0-3.417-0.664-4.595-1.971     c-1.169-1.289-1.759-2.928-1.759-4.881c0-1.989,0.589-3.646,1.759-4.918c1.188-1.279,2.735-1.934,4.595-1.934     c1.832,0,3.36,0.653,4.549,1.934c1.169,1.281,1.759,2.929,1.759,4.918C106.987,74.907,106.397,76.555,105.228,77.844z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.019,
    y: 43.561,
    fill: "url(#SVGID_7_)",
    width: 8.481,
    height: 42.773
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151.207,
    y: 59.584,
    fill: "url(#SVGID_8_)",
    width: 8.481,
    height: 26.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M155.415,44.647c-1.39,0-2.532,0.433-3.48,1.317c-0.93,0.866-1.381,1.943-1.381,3.278     c0,1.271,0.451,2.32,1.391,3.213c0.948,0.894,2.081,1.336,3.471,1.336c1.391,0,2.523-0.442,3.454-1.336     c0.921-0.894,1.363-1.942,1.363-3.213c0-1.335-0.441-2.413-1.363-3.288C157.938,45.08,156.814,44.647,155.415,44.647z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M184.965,58.718c-1.731,0-3.27,0.351-4.577,1.06c-1.29,0.69-2.293,1.703-2.993,2.993     l-1.216,2.267l-0.166-5.453h-8.297v26.752h8.49v-14.19c0-1.86,0.406-3.325,1.207-4.374c0.837-1.105,2.063-1.658,3.628-1.658     c2.035,0,4.457,0.977,4.457,5.654v14.568h8.481v-16.43c0-3.701-0.792-6.539-2.348-8.417     C190.085,59.622,187.903,58.718,184.965,58.718z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M214.064,70.192c-1.796-0.497-2.982-0.939-3.637-1.372c-0.977-0.635-1.18-1.455-1.18-2.016     c0-1.144,0.664-2.496,3.85-2.496c2.615,0,5.304,0.608,8.012,1.805l0.782-5.479c-1.067-0.543-2.403-0.993-3.978-1.334     c-1.795-0.387-3.638-0.581-5.471-0.581c-3.572,0-6.408,0.745-8.416,2.229c-1.98,1.464-2.938,3.444-2.938,6.068     c0,2.265,0.655,3.978,1.991,5.258c1.379,1.308,3.783,2.44,7.146,3.353c1.833,0.487,3.021,0.92,3.628,1.308     c0.745,0.47,1.143,1.188,1.143,2.082c0,1.188-0.765,2.597-4.402,2.597c-1.694,0-3.426-0.249-5.147-0.736     c-1.39-0.387-2.698-0.931-3.922-1.611l-0.866,5.517c1.125,0.683,2.587,1.253,4.375,1.685c2.008,0.498,4.098,0.746,6.217,0.746     c3.83,0,6.84-0.746,8.949-2.219c2.063-1.437,3.059-3.406,3.059-6.031c0-2.229-0.663-3.969-2.026-5.313     C219.83,72.264,217.417,71.104,214.064,70.192z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M234.305,44.647c-1.392,0-2.532,0.433-3.481,1.317c-0.93,0.866-1.39,1.943-1.39,3.278     c0,1.271,0.46,2.32,1.399,3.213c0.949,0.894,2.08,1.336,3.472,1.336c1.391,0,2.522-0.442,3.444-1.336     c0.93-0.894,1.371-1.942,1.371-3.213c0-1.335-0.441-2.413-1.363-3.288C236.83,45.08,235.696,44.647,234.305,44.647z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230.087,
    y: 59.584,
    fill: "url(#SVGID_13_)",
    width: 8.49,
    height: 26.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M266.278,64.897l-1.216-2.054c-0.766-1.3-1.822-2.321-3.141-3.039     c-1.336-0.728-2.846-1.087-4.494-1.087c-2.284,0-4.365,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.347,5.028     c-1.076,2.127-1.621,4.577-1.621,7.293s0.516,5.156,1.511,7.248c0.995,2.081,2.403,3.719,4.181,4.88     c1.758,1.151,3.84,1.741,6.16,1.741c3.628,0,6.217-1.346,7.92-4.09l1.271-2.071v4.503c0,5.441-3.066,8.325-8.858,8.325     c-1.437,0-3.011-0.222-4.696-0.646c-1.289-0.332-2.432-0.727-3.416-1.179l-0.848,6.64c0.645,0.321,1.455,0.616,2.413,0.883     c1.179,0.341,2.478,0.607,3.858,0.802c1.381,0.192,2.744,0.294,4.043,0.294c5.129,0,9.051-1.316,11.647-3.914     s3.914-6.475,3.914-11.529V59.584h-7.966L266.278,64.897z M264.638,77.624c-1.18,1.309-2.707,1.971-4.54,1.971     c-1.869,0-3.416-0.663-4.604-1.971c-1.168-1.289-1.758-2.928-1.758-4.879c0-1.99,0.59-3.639,1.758-4.91     c1.189-1.289,2.735-1.942,4.604-1.942c1.823,0,3.353,0.653,4.54,1.942c1.169,1.271,1.759,2.92,1.759,4.91     C266.397,74.695,265.808,76.334,264.638,77.624z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M299.677,58.718c-1.694,0-3.215,0.341-4.512,1.004c-1.271,0.663-2.267,1.621-2.957,2.836     l-1.289,2.274V43.561h-8.49v42.773h8.49V72.145c0-1.859,0.404-3.325,1.207-4.374c0.838-1.104,2.063-1.658,3.627-1.658     c2.026,0,4.449,0.976,4.449,5.654v14.567h8.489V69.907c0-3.701-0.792-6.539-2.349-8.417     C304.789,59.622,302.615,58.718,299.677,58.718z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_16_)",
    points: "327.552,52.336 319.07,52.336 319.07,59.584 314.328,59.584 314.328,66.113      319.07,66.113 319.07,86.334 327.552,86.334 327.552,66.113 333.279,66.113 333.279,59.584 327.552,59.584    "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M359.432,73.645c-1.39-1.381-3.804-2.542-7.165-3.453c-1.795-0.497-2.982-0.939-3.627-1.372     c-0.986-0.635-1.188-1.455-1.188-2.016c0-1.144,0.672-2.496,3.857-2.496c2.615,0,5.304,0.608,8.002,1.805l0.783-5.479     c-1.068-0.543-2.404-0.993-3.969-1.334c-1.806-0.387-3.647-0.581-5.471-0.581c-3.582,0-6.418,0.745-8.426,2.229     c-1.979,1.464-2.938,3.444-2.938,6.068c0,2.265,0.653,3.978,1.998,5.258c1.381,1.308,3.785,2.44,7.146,3.353     c1.824,0.487,3.012,0.92,3.619,1.308c0.746,0.47,1.143,1.188,1.143,2.082c0,1.188-0.766,2.597-4.402,2.597     c-1.694,0-3.426-0.249-5.147-0.736c-1.381-0.387-2.698-0.931-3.923-1.611l-0.866,5.517c1.124,0.683,2.597,1.253,4.375,1.685     c2.017,0.498,4.106,0.746,6.216,0.746c3.838,0,6.85-0.746,8.959-2.219c2.053-1.437,3.057-3.406,3.057-6.031     C361.466,76.73,360.804,74.99,359.432,73.645z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.382,
    y: 43.561,
    fill: "url(#SVGID_18_)",
    width: 8.49,
    height: 42.773
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M37.655,60.348c-1.961-1.086-4.327-1.63-7.026-1.63c-2.781,0-5.249,0.599-7.348,1.786    c-2.09,1.188-3.748,2.863-4.917,4.992c-1.169,2.145-1.768,4.649-1.768,7.467c0,2.947,0.654,5.508,1.943,7.625    c1.289,2.108,3.148,3.757,5.543,4.89c2.421,1.151,5.377,1.731,8.775,1.731c1.989,0,3.951-0.185,5.848-0.535    c1.685-0.313,3.223-0.764,4.585-1.325l-0.7-5.664c-1.068,0.433-2.275,0.792-3.591,1.067c-1.667,0.351-3.296,0.535-4.825,0.535    c-2.588,0-4.678-0.471-6.216-1.382c-1.603-0.948-2.652-2.477-3.131-4.558l-0.193-0.838h18.961    c0.027-0.322,0.055-0.635,0.082-0.939c0.038-0.497,0.056-0.984,0.056-1.482c0-2.779-0.534-5.192-1.583-7.172    C41.109,62.956,39.598,61.417,37.655,60.348z M35.952,70.542H24.524l0.129-0.801c0.801-4.76,3.6-5.755,5.811-5.755    c1.446,0,2.652,0.433,3.583,1.3c0.893,0.846,1.5,1.979,1.786,3.389c0.074,0.378,0.12,0.772,0.12,1.179L35.952,70.542    L35.952,70.542z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M71.045,64.897l-1.215-2.054c-0.765-1.3-1.823-2.321-3.14-3.039    c-1.335-0.728-2.846-1.087-4.494-1.087c-2.283,0-4.355,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.346,5.028    c-1.078,2.127-1.621,4.577-1.621,7.293s0.516,5.156,1.519,7.248c0.985,2.081,2.395,3.719,4.172,4.88    c1.759,1.151,3.84,1.741,6.161,1.741c3.628,0,6.216-1.346,7.919-4.09l1.28-2.071v4.503c0,5.441-3.066,8.325-8.868,8.325    c-1.437,0-3.011-0.222-4.696-0.646c-1.28-0.332-2.432-0.727-3.417-1.179l-0.847,6.64c0.645,0.321,1.455,0.616,2.412,0.883    c1.179,0.341,2.478,0.607,3.859,0.802c1.381,0.192,2.744,0.294,4.042,0.294c5.129,0,9.052-1.316,11.649-3.914    c2.597-2.598,3.914-6.475,3.914-11.529V59.584h-7.966L71.045,64.897z M69.407,77.624c-1.179,1.309-2.708,1.971-4.54,1.971    c-1.87,0-3.417-0.663-4.604-1.971c-1.169-1.289-1.759-2.928-1.759-4.879c0-1.99,0.59-3.639,1.759-4.91    c1.188-1.289,2.735-1.942,4.604-1.942c1.823,0,3.352,0.653,4.54,1.942c1.169,1.271,1.759,2.92,1.759,4.91    C71.166,74.695,70.576,76.334,69.407,77.624z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M106.858,64.989l-1.216-2.154c-0.727-1.299-1.777-2.313-3.103-3.029    c-1.344-0.729-2.891-1.087-4.586-1.087c-2.237,0-4.292,0.626-6.096,1.86c-1.814,1.262-3.279,2.975-4.347,5.11    c-1.078,2.146-1.621,4.632-1.621,7.385c0,2.79,0.506,5.285,1.519,7.413c0.995,2.118,2.385,3.785,4.144,4.954    c1.75,1.179,3.794,1.769,6.078,1.769c3.803,0,6.418-1.363,8.011-4.172l1.216-2.154l0.166,5.451h7.966v-26.75h-7.966    L106.858,64.989z M105.228,77.844c-1.188,1.308-2.717,1.971-4.549,1.971c-1.86,0-3.417-0.664-4.595-1.971    c-1.169-1.289-1.759-2.928-1.759-4.881c0-1.989,0.589-3.646,1.759-4.918c1.188-1.279,2.735-1.934,4.595-1.934    c1.832,0,3.36,0.653,4.549,1.934c1.169,1.281,1.759,2.929,1.759,4.918C106.987,74.907,106.397,76.555,105.228,77.844z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 123.019,
    y: 43.561,
    fill: "url(#SVGID_22_)",
    width: 8.481,
    height: 42.773
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 151.207,
    y: 59.584,
    fill: "url(#SVGID_23_)",
    width: 8.481,
    height: 26.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M155.415,44.647c-1.39,0-2.532,0.433-3.48,1.317c-0.93,0.866-1.381,1.943-1.381,3.278    c0,1.271,0.451,2.32,1.391,3.213c0.948,0.894,2.081,1.336,3.471,1.336c1.391,0,2.523-0.442,3.454-1.336    c0.921-0.894,1.363-1.942,1.363-3.213c0-1.335-0.441-2.413-1.363-3.288C157.938,45.08,156.814,44.647,155.415,44.647z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M184.965,58.718c-1.731,0-3.27,0.351-4.577,1.06c-1.29,0.69-2.293,1.703-2.993,2.993l-1.216,2.267    l-0.166-5.453h-8.297v26.752h8.49v-14.19c0-1.86,0.406-3.325,1.207-4.374c0.837-1.105,2.063-1.658,3.628-1.658    c2.035,0,4.457,0.977,4.457,5.654v14.568h8.481v-16.43c0-3.701-0.792-6.539-2.348-8.417    C190.085,59.622,187.903,58.718,184.965,58.718z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M214.064,70.192c-1.796-0.497-2.982-0.939-3.637-1.372c-0.977-0.635-1.18-1.455-1.18-2.016    c0-1.144,0.664-2.496,3.85-2.496c2.615,0,5.304,0.608,8.012,1.805l0.782-5.479c-1.067-0.543-2.403-0.993-3.978-1.334    c-1.795-0.387-3.638-0.581-5.471-0.581c-3.572,0-6.408,0.745-8.416,2.229c-1.98,1.464-2.938,3.444-2.938,6.068    c0,2.265,0.655,3.978,1.991,5.258c1.379,1.308,3.783,2.44,7.146,3.353c1.833,0.487,3.021,0.92,3.628,1.308    c0.745,0.47,1.143,1.188,1.143,2.082c0,1.188-0.765,2.597-4.402,2.597c-1.694,0-3.426-0.249-5.147-0.736    c-1.39-0.387-2.698-0.931-3.922-1.611l-0.866,5.517c1.125,0.683,2.587,1.253,4.375,1.685c2.008,0.498,4.098,0.746,6.217,0.746    c3.83,0,6.84-0.746,8.949-2.219c2.063-1.437,3.059-3.406,3.059-6.031c0-2.229-0.663-3.969-2.026-5.313    C219.83,72.264,217.417,71.104,214.064,70.192z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M234.305,44.647c-1.392,0-2.532,0.433-3.481,1.317c-0.93,0.866-1.39,1.943-1.39,3.278    c0,1.271,0.46,2.32,1.399,3.213c0.949,0.894,2.08,1.336,3.472,1.336c1.391,0,2.522-0.442,3.444-1.336    c0.93-0.894,1.371-1.942,1.371-3.213c0-1.335-0.441-2.413-1.363-3.288C236.83,45.08,235.696,44.647,234.305,44.647z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230.087,
    y: 59.584,
    fill: "url(#SVGID_28_)",
    width: 8.49,
    height: 26.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M266.278,64.897l-1.216-2.054c-0.766-1.3-1.822-2.321-3.141-3.039    c-1.336-0.728-2.846-1.087-4.494-1.087c-2.284,0-4.365,0.607-6.161,1.813c-1.823,1.216-3.278,2.91-4.347,5.028    c-1.076,2.127-1.621,4.577-1.621,7.293s0.516,5.156,1.511,7.248c0.995,2.081,2.403,3.719,4.181,4.88    c1.758,1.151,3.84,1.741,6.16,1.741c3.628,0,6.217-1.346,7.92-4.09l1.271-2.071v4.503c0,5.441-3.066,8.325-8.858,8.325    c-1.437,0-3.011-0.222-4.696-0.646c-1.289-0.332-2.432-0.727-3.416-1.179l-0.848,6.64c0.645,0.321,1.455,0.616,2.413,0.883    c1.179,0.341,2.478,0.607,3.858,0.802c1.381,0.192,2.744,0.294,4.043,0.294c5.129,0,9.051-1.316,11.647-3.914    s3.914-6.475,3.914-11.529V59.584h-7.966L266.278,64.897z M264.638,77.624c-1.18,1.309-2.707,1.971-4.54,1.971    c-1.869,0-3.416-0.663-4.604-1.971c-1.168-1.289-1.758-2.928-1.758-4.879c0-1.99,0.59-3.639,1.758-4.91    c1.189-1.289,2.735-1.942,4.604-1.942c1.823,0,3.353,0.653,4.54,1.942c1.169,1.271,1.759,2.92,1.759,4.91    C266.397,74.695,265.808,76.334,264.638,77.624z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M299.677,58.718c-1.694,0-3.215,0.341-4.512,1.004c-1.271,0.663-2.267,1.621-2.957,2.836    l-1.289,2.274V43.561h-8.49v42.773h8.49V72.145c0-1.859,0.404-3.325,1.207-4.374c0.838-1.104,2.063-1.658,3.627-1.658    c2.026,0,4.449,0.976,4.449,5.654v14.567h8.489V69.907c0-3.701-0.792-6.539-2.349-8.417    C304.789,59.622,302.615,58.718,299.677,58.718z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_31_)",
    points: "327.552,52.336 319.07,52.336 319.07,59.584 314.328,59.584 314.328,66.113     319.07,66.113 319.07,86.334 327.552,86.334 327.552,66.113 333.279,66.113 333.279,59.584 327.552,59.584   "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.3818,
    y1: 71.8716,
    x2: 361.4663,
    y2: 71.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4E1975"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#AC59FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8BB5E0"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M359.432,73.645c-1.39-1.381-3.804-2.542-7.165-3.453c-1.795-0.497-2.982-0.939-3.627-1.372    c-0.986-0.635-1.188-1.455-1.188-2.016c0-1.144,0.672-2.496,3.857-2.496c2.615,0,5.304,0.608,8.002,1.805l0.783-5.479    c-1.068-0.543-2.404-0.993-3.969-1.334c-1.806-0.387-3.647-0.581-5.471-0.581c-3.582,0-6.418,0.745-8.426,2.229    c-1.979,1.464-2.938,3.444-2.938,6.068c0,2.265,0.653,3.978,1.998,5.258c1.381,1.308,3.785,2.44,7.146,3.353    c1.824,0.487,3.012,0.92,3.619,1.308c0.746,0.47,1.143,1.188,1.143,2.082c0,1.188-0.766,2.597-4.402,2.597    c-1.694,0-3.426-0.249-5.147-0.736c-1.381-0.387-2.698-0.931-3.923-1.611l-0.866,5.517c1.124,0.683,2.597,1.253,4.375,1.685    c2.017,0.498,4.106,0.746,6.216,0.746c3.838,0,6.85-0.746,8.959-2.219c2.053-1.437,3.057-3.406,3.057-6.031    C361.466,76.73,360.804,74.99,359.432,73.645z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLegalInsightsV2);
export default __webpack_public_path__ + "static/media/Logo-Legal-Insights-v2.b7b005f4582a6d1115bbbf0488855f10.svg";
export { ForwardRef as ReactComponent };